import api from '../../../helpers/api';

// export const getPrivateInquiries = (body) =>
//   api.post("moderation-pool/get-pending-artisans-private-inquiry", { ...body });

export const getPrivateInquiries = body =>
  api.post(
    body.url
      ? body.url
      : 'private-artisan-inquiry-staging/search-artisan-private-inquiries/',
    { ...body }
  );

export const updatePrivateInquiry = body =>
  api.post('moderation-pool/moderate-artisans-private-inquiry', { ...body });

export const getSingleArtisanPrivateInquiry = id =>
  api.get(`private-artisan-inquiry-staging/${id}`);

export const rejectSingleArtisanPrivateInquiry = id =>
  api.put(`private-artisan-inquiry-staging/reject/${id}`);

export const moderateCreateArtisanInquiry = id =>
  api.post(`private-artisan-inquiry-staging/moderate-create`, id);
export const moderateUpdateArtisanInquiry = id =>
  api.post(`private-artisan-inquiry-staging/moderate-update`, id);
